import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Beaker, TestTube, Award, ShoppingBag, Globe, RefreshCw, ArrowRight } from 'lucide-react';
const ResearchPage = () => {
  return <div className="min-h-screen bg-white" data-id="element-702" data-mp="3oead8zmdhbpg">
      <Navbar data-id="element-703" data-mp="3jh0dor59rjnw" />
      {/* Hero Section */}
      <div className="relative bg-gradient-to-r from-teal-900 to-teal-800 text-white" data-id="element-704" data-mp="3jfz3eow2v178">
        <div className="absolute inset-0 overflow-hidden" data-id="element-705" data-mp="3eiqgkazzi8zn">
          <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1581093588401-fbb62a02f120?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80')] bg-cover bg-center opacity-20" data-id="element-706" data-mp="39iknqrhzagfz"></div>
        </div>
        <div className="relative container mx-auto px-4 py-24 max-w-7xl" data-id="element-707" data-mp="30ifq392l6wf0">
          <div className="max-w-3xl" data-id="element-708" data-mp="30k8wcn9afemh">
            <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-709" data-mp="13pvzgenqcjk6">
              CalBiome Research Model
            </h1>
            <p className="text-xl mb-8 text-teal-100" data-id="element-710" data-mp="yrugruu7um98">
              Translating scientific discovery into validated microbiome
              solutions
            </p>
          </div>
        </div>
      </div>
      {/* Main Content */}
      <div className="container mx-auto px-4 py-16 max-w-7xl" data-id="element-711" data-mp="bu0kp393tqfg">
        {/* Introduction */}
        <div className="mb-16 max-w-3xl mx-auto text-center" data-id="element-712" data-mp="3u42nho1vhym8">
          <h2 className="text-3xl font-bold text-gray-800 mb-6" data-id="element-713" data-mp="2whtfh4vafv4">
            Our Science-First Approach
          </h2>
          <p className="text-lg text-gray-700" data-id="element-714" data-mp="qm2q12ty1bmv">
            CalBiome's Research Model represents a continuous cycle of
            discovery, development, validation, and implementation. Each product
            and protocol follows a rigorous path from laboratory research to
            real-world application.
          </p>
        </div>
        {/* Research Model Steps */}
        <div className="space-y-16" data-id="element-715" data-mp="19jdctnye2clf">
          {/* Step 1 */}
          <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-716" data-mp="1ealo6pja4818">
            <div className="md:w-1/3 flex justify-center" data-id="element-717" data-mp="1ecyatfzzf6km">
              <div className="w-32 h-32 bg-teal-100 rounded-full flex items-center justify-center" data-id="element-718" data-mp="1o5j3qzovrdqg">
                <div size={64} className="text-teal-600" data-id="element-719" data-mp="1j92h69xbx7fh" />
              </div>
            </div>
            <div className="md:w-2/3" data-id="element-720" data-mp="1e7mrg4k7icqr">
              <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-8" data-id="element-721" data-mp="1ear31n004arg">
                <h3 className="text-2xl font-bold text-teal-800 mb-4" data-id="element-722" data-mp="19bnzy83l0em4">
                  1. Scientific Discovery from CalMiR
                </h3>
                <p className="text-gray-700 mb-4" data-id="element-723" data-mp="10gq3ir186jq1">
                  CalBiome begins with validated findings from the California
                  Institute for Microbiome Research (CalMiR).
                </p>
                <ul className="space-y-2 text-gray-700" data-id="element-724" data-mp="qjv9akbzj5hk">
                  <li className="flex items-start" data-id="element-725" data-mp="qh92wo0tyw0x">
                    <ArrowRight size={18} className="text-teal-600 mr-2 mt-1 flex-shrink-0" data-id="element-726" data-mp="lipd2cj4903a" />
                    <span data-id="element-727" data-mp="2t60uxxsfet0a">
                      Mechanistic insights (biofilm disruption, gut barrier
                      studies)
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-728" data-mp="2x970f37psg5p">
                    <ArrowRight size={18} className="text-teal-600 mr-2 mt-1 flex-shrink-0" data-id="element-729" data-mp="327grp2qbiwm1" />
                    <span data-id="element-730" data-mp="29hroqju1smhs">
                      Applied compound testing (NAC, probiotics, phytonutrients)
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-731" data-mp="2ehe2qvhpa6rn">
                    <ArrowRight size={18} className="text-teal-600 mr-2 mt-1 flex-shrink-0" data-id="element-732" data-mp="2jffndkurye58" />
                    <span data-id="element-733" data-mp="2o7z42qordpe9">Early-stage clinical data</span>
                  </li>
                </ul>
                <p className="text-gray-700 mt-4" data-id="element-734" data-mp="1qp60aklgzy78">
                  Research is grounded in peer-reviewed methods, ensuring
                  credibility from the start.
                </p>
              </div>
            </div>
          </div>
          {/* Step 2 */}
          <div className="flex flex-col md:flex-row gap-8 items-center md:flex-row-reverse" data-id="element-735" data-mp="3teyybkf85rhg">
            <div className="md:w-1/3 flex justify-center" data-id="element-736" data-mp="b0zovdh2ek7o">
              <div className="w-32 h-32 bg-teal-100 rounded-full flex items-center justify-center" data-id="element-737" data-mp="697yp41tmgi2">
                <Beaker size={64} className="text-teal-600" data-id="element-738" data-mp="ky41omp0t3bt" />
              </div>
            </div>
            <div className="md:w-2/3" data-id="element-739" data-mp="fz175w6o2fi3">
              <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-8" data-id="element-740" data-mp="fxzmczzumen6">
                <h3 className="text-2xl font-bold text-teal-800 mb-4" data-id="element-741" data-mp="tz29zh6hrx07">
                  2. Applied Development
                </h3>
                <p className="text-gray-700 mb-4" data-id="element-742" data-mp="p0ikx7wlq53m">
                  CalBiome translates lab discoveries into practical protocols
                  and products:
                </p>
                <ul className="space-y-2 text-gray-700" data-id="element-743" data-mp="2qsdsbbbtrng1">
                  <li className="flex items-start" data-id="element-744" data-mp="169bf4ccds7q6">
                    <ArrowRight size={18} className="text-teal-600 mr-2 mt-1 flex-shrink-0" data-id="element-745" data-mp="169l5w2592iwx" />
                    <span data-id="element-746" data-mp="xh9hsmxlz7k4">
                      <strong data-id="element-747" data-mp="xfyespbzm3u2">Formulation:</strong> Combining probiotics,
                      cofactors, and biofilm disruptors into effective blends.
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-748" data-mp="nhsf8ednl9sd">
                    <ArrowRight size={18} className="text-teal-600 mr-2 mt-1 flex-shrink-0" data-id="element-749" data-mp="shdc8j99j82g" />
                    <span data-id="element-750" data-mp="ejggtq6jp7pd">
                      <strong data-id="element-751" data-mp="ek86ylhdid89">Protocol Design:</strong> Structured regimens
                      (e.g., the Microbiota Reset Protocol) that integrate
                      lifestyle and supplementation.
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-752" data-mp="2cw6xcfu61yew">
                    <ArrowRight size={18} className="text-teal-600 mr-2 mt-1 flex-shrink-0" data-id="element-753" data-mp="3luf662v4981p" />
                    <span data-id="element-754" data-mp="3gtsi4k23ico9">
                      <strong data-id="element-755" data-mp="3gxoqhgn84egt">Safety Testing:</strong> Screening for purity,
                      dosage accuracy, and interactions.
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {/* Step 3 */}
          <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-756" data-mp="8eqwtexg8wwy">
            <div className="md:w-1/3 flex justify-center" data-id="element-757" data-mp="4f00kvp5lol1">
              <div className="w-32 h-32 bg-teal-100 rounded-full flex items-center justify-center" data-id="element-758" data-mp="3vsmig8egn1xd">
                <TestTube size={64} className="text-teal-600" data-id="element-759" data-mp="3qtjfqulyd7sk" />
              </div>
            </div>
            <div className="md:w-2/3" data-id="element-760" data-mp="s3j9ndg125e6">
              <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-8" data-id="element-761" data-mp="s4b3ojtz7v2c">
                <h3 className="text-2xl font-bold text-teal-800 mb-4" data-id="element-762" data-mp="nbrqvp3453yl">
                  3. Iterative Testing & Validation
                </h3>
                <ul className="space-y-4 text-gray-700" data-id="element-763" data-mp="uq244mogteje">
                  <li data-id="element-764" data-mp="zo3i4t71ano0">
                    <p className="font-semibold" data-id="element-765" data-mp="znalwm5pbgk4">In Vitro:</p>
                    <p data-id="element-766" data-mp="14lvm4lkye08k">
                      Petri dish and organoid gut models for functional
                      validation.
                    </p>
                  </li>
                  <li data-id="element-767" data-mp="1dn38q6e3xcmt">
                    <p className="font-semibold" data-id="element-768" data-mp="1dnlbzmz6sr48">Preclinical Models:</p>
                    <p data-id="element-769" data-mp="1ilwknudqwvkv">
                      Gnotobiotic mice and animal studies for systemic outcomes.
                    </p>
                  </li>
                  <li data-id="element-770" data-mp="1nd4xl0eaaz2s">
                    <p className="font-semibold" data-id="element-771" data-mp="1neprcnsrydzl">Human Pilot Trials:</p>
                    <p data-id="element-772" data-mp="1saem8dtun6pk">
                      Exploratory studies on tolerability, efficacy, biomarkers,
                      and patient-reported outcomes.
                    </p>
                  </li>
                </ul>
                <p className="text-gray-700 mt-4" data-id="element-773" data-mp="21abe0objclou">
                  Each iteration informs product refinement before release.
                </p>
              </div>
            </div>
          </div>
          {/* Step 4 */}
          <div className="flex flex-col md:flex-row gap-8 items-center md:flex-row-reverse" data-id="element-774" data-mp="2wliix5ie5h68">
            <div className="md:w-1/3 flex justify-center" data-id="element-775" data-mp="2rmfqqlnif5fo">
              <div className="w-32 h-32 bg-teal-100 rounded-full flex items-center justify-center" data-id="element-776" data-mp="2rmyzbbr9shh1">
                <Award size={64} className="text-teal-600" data-id="element-777" data-mp="23xcy6irc7s6e" />
              </div>
            </div>
            <div className="md:w-2/3" data-id="element-778" data-mp="1yzbhg4hdw4y3">
              <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-8" data-id="element-779" data-mp="2dmo7o6i4yyut">
                <h3 className="text-2xl font-bold text-teal-800 mb-4" data-id="element-780" data-mp="2dohgnsg81v5z">
                  4. Independent Certification
                </h3>
                <p className="text-gray-700 mb-4" data-id="element-781" data-mp="1l5k5kpg6k8z7">
                  Every CalBiome product undergoes the Ukweli Certified™
                  program.
                </p>
                <p className="text-gray-700 mb-2 font-semibold" data-id="element-782" data-mp="3rum89p6ijkjr">
                  Levels of certification:
                </p>
                <ul className="space-y-2 text-gray-700" data-id="element-783" data-mp="g7zvg2guzo0">
                  <li className="flex items-start" data-id="element-784" data-mp="hrl7l2zc0wn">
                    <ArrowRight size={18} className="text-teal-600 mr-2 mt-1 flex-shrink-0" data-id="element-785" data-mp="3hxhlpo8r9n2f" />
                    <span data-id="element-786" data-mp="efpsy7msoz36">
                      <strong data-id="element-787" data-mp="efg4wplb9204">Evidence Screen</strong> – Purity & safety.
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-788" data-mp="jdhk2zfm8h6b">
                    <ArrowRight size={18} className="text-teal-600 mr-2 mt-1 flex-shrink-0" data-id="element-789" data-mp="5fb7n89tzjzo" />
                    <span data-id="element-790" data-mp="9ethn9046anq">
                      <strong data-id="element-791" data-mp="2q5a1yexydujt">Mechanistic Validation</strong> – Biological
                      plausibility.
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-792" data-mp="2u8f3ae6arq6v">
                    <ArrowRight size={18} className="text-teal-600 mr-2 mt-1 flex-shrink-0" data-id="element-793" data-mp="332i2n96nbvuf" />
                    <span data-id="element-794" data-mp="380jizmcoth27">
                      <strong data-id="element-795" data-mp="2u9wl1wer3v76">Clinical Validation</strong> – Human efficacy.
                    </span>
                  </li>
                </ul>
                <p className="text-gray-700 mt-4" data-id="element-796" data-mp="2yagil138l0tu">
                  This ensures that all products meet external, independent
                  credibility standards.
                </p>
              </div>
            </div>
          </div>
          {/* Step 5 */}
          <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-797" data-mp="2bbbvi8sicxvn">
            <div className="md:w-1/3 flex justify-center" data-id="element-798" data-mp="2bd57m3lw4ab1">
              <div className="w-32 h-32 bg-teal-100 rounded-full flex items-center justify-center" data-id="element-799" data-mp="2fdp4d62jxbwn">
                <ShoppingBag size={64} className="text-teal-600" data-id="element-800" data-mp="9l0h8wk1hl2f" />
              </div>
            </div>
            <div className="md:w-2/3" data-id="element-801" data-mp="djzk8bm7n7r8">
              <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-8" data-id="element-802" data-mp="diy5nx5zk34r">
                <h3 className="text-2xl font-bold text-teal-800 mb-4" data-id="element-803" data-mp="1y18rjxiv87a5">
                  5. Commercial Translation
                </h3>
                <ul className="space-y-2 text-gray-700" data-id="element-804" data-mp="27to7kpalqlse">
                  <li className="flex items-start" data-id="element-805" data-mp="27v7ngesciutn">
                    <ArrowRight size={18} className="text-teal-600 mr-2 mt-1 flex-shrink-0" data-id="element-806" data-mp="23263hsda8537" />
                    <span data-id="element-807" data-mp="2ht5d96puszod">
                      Products are launched as supplement lines, reset kits, and
                      therapeutic protocols.
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-808" data-mp="2qpmla12x8hfw">
                    <ArrowRight size={18} className="text-teal-600 mr-2 mt-1 flex-shrink-0" data-id="element-809" data-mp="2lu7dnqvibhrx" />
                    <span data-id="element-810" data-mp="rf4qhztxkbs6">
                      Consumer-facing branding emphasizes science-first trust,
                      distinct from typical marketing-driven wellness companies.
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-811" data-mp="2wha9k14f6vxj">
                    <ArrowRight size={18} className="text-teal-600 mr-2 mt-1 flex-shrink-0" data-id="element-812" data-mp="31fbny8qwi72o" />
                    <span data-id="element-813" data-mp="35igq2a72k6qs">
                      Physicians, health practitioners, and wellness providers
                      are also targeted as key users.
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {/* Step 6 */}
          <div className="flex flex-col md:flex-row gap-8 items-center md:flex-row-reverse" data-id="element-814" data-mp="3k6bjjsswif4x">
            <div className="md:w-1/3 flex justify-center" data-id="element-815" data-mp="3p4d30eu8oggx">
              <div className="w-32 h-32 bg-teal-100 rounded-full flex items-center justify-center" data-id="element-816" data-mp="3t6zycpq4cjiv">
                <Globe size={64} className="text-teal-600" data-id="element-817" data-mp="1znh6ap8k62y" />
              </div>
            </div>
            <div className="md:w-2/3" data-id="element-818" data-mp="1miqwybfz7592">
              <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-8" data-id="element-819" data-mp="1mjsjbc2fze63">
                <h3 className="text-2xl font-bold text-teal-800 mb-4" data-id="element-820" data-mp="1hid07pjtrhqc">
                  6. Global Equity via Afya
                </h3>
                <p className="text-gray-700 mb-4" data-id="element-821" data-mp="1djdwu9dqrt10">
                  Once validated, CalBiome protocols are adapted through the
                  Afya Program for underserved populations.
                </p>
                <p className="text-gray-700 mb-2" data-id="element-822" data-mp="2173vng6g7279">This involves:</p>
                <ul className="space-y-2 text-gray-700" data-id="element-823" data-mp="217x5wr4m89u5">
                  <li className="flex items-start" data-id="element-824" data-mp="1wfvo6poohqwq">
                    <ArrowRight size={18} className="text-teal-600 mr-2 mt-1 flex-shrink-0" data-id="element-825" data-mp="1weaqwsazbtv6" />
                    <span data-id="element-826" data-mp="2oxrgt35djobr">Low-cost diagnostic kits.</span>
                  </li>
                  <li className="flex items-start" data-id="element-827" data-mp="2k5g6r7gx6m5h">
                    <ArrowRight size={18} className="text-teal-600 mr-2 mt-1 flex-shrink-0" data-id="element-828" data-mp="2k4oloqky86tg" />
                    <span data-id="element-829" data-mp="28ptmeikrmsaw">Simplified formulations.</span>
                  </li>
                  <li className="flex items-start" data-id="element-830" data-mp="1uq2445n7upr3">
                    <ArrowRight size={18} className="text-teal-600 mr-2 mt-1 flex-shrink-0" data-id="element-831" data-mp="1urmy9u5mc6of" />
                    <span data-id="element-832" data-mp="2ndy0tacschnv">Training modules for local health workers.</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {/* Step 7 */}
          <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-833" data-mp="2dp6a15jgo3ej">
            <div className="md:w-1/3 flex justify-center" data-id="element-834" data-mp="2dmts2sdpdt1h">
              <div className="w-32 h-32 bg-teal-100 rounded-full flex items-center justify-center" data-id="element-835" data-mp="2img5p2xg1bat">
                <RefreshCw size={64} className="text-teal-600" data-id="element-836" data-mp="36br1e5zxsfi3" />
              </div>
            </div>
            <div className="md:w-2/3" data-id="element-837" data-mp="3b5lhz0k8wecy">
              <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-8" data-id="element-838" data-mp="3kiuan4pqjpl7">
                <h3 className="text-2xl font-bold text-teal-800 mb-4" data-id="element-839" data-mp="3kghmg9tdwizp">
                  7. Feedback Loop
                </h3>
                <p className="text-gray-700 mb-4" data-id="element-840" data-mp="3u96ueupq7eqa">
                  Consumer data, clinical outcomes, and global field results
                  feed back into CalMiR's research engine.
                </p>
                <p className="text-gray-700" data-id="element-841" data-mp="31j80akwocrer">
                  This creates a continuous improvement cycle: discovery →
                  productization → validation → global adoption → new insights.
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* Summary */}
        <div className="mt-16 bg-gradient-to-r from-teal-50 to-teal-100 rounded-lg p-8 border border-teal-100" data-id="element-842" data-mp="36i1fchrm0qh1">
          <h3 className="text-2xl font-bold text-teal-800 mb-4" data-id="element-843" data-mp="qqn9yedahd61">In Summary</h3>
          <p className="text-xl text-gray-700" data-id="element-844" data-mp="ltn2q04pe4dc">
            CalBiome's Research Model is translational — taking CalMiR's
            discoveries, rigorously testing them, validating through Ukweli, and
            delivering science-backed protocols and products globally.
          </p>
        </div>
      </div>
      <Footer data-id="element-845" data-mp="12v9gx55u4i1j" />
    </div>;
};
export default ResearchPage;